import*as r from"react";import{styled as e}from"@linaria/react";const t=e("ol")({name:"StyledDotsWrapper",class:"s12zymgj",propsAsIs:!1}),a=({children:e})=>r.createElement(t,null,e);export{a as Dots};
//# sourceMappingURL=Dots.js.map
